const GET_USER_AUTH_DATA = `
  query  {
    session @client {
      isLoggedIn
      authToken
      userData {
        firstname,
        lastname, 
        id
      }
    }
  }
`;

export { GET_USER_AUTH_DATA };
